import { render } from "./Title4App.vue?vue&type=template&id=24f880b2"
import script from "./Title4App.vue?vue&type=script&lang=js"
export * from "./Title4App.vue?vue&type=script&lang=js"

import "./Title4App.vue?vue&type=style&index=0&id=24f880b2&lang=css"

import exportComponent from "/home/nimens/projects/cafe-portos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__